import React from "react";
import { Avatar, Space, Typography } from "antd";
import { useGetIdentity } from "@refinedev/core";

export const CurrentUser: React.FC = () => {
  const { data } = useGetIdentity<{ email?: string; name?: string }>();
  const name = data?.name || data?.email || "";
  const letter = (name || "").charAt(0).toUpperCase() || "A";
  return (
    <Space align="center">
      <Avatar size={28}>{letter}</Avatar>
      <Typography.Text strong>{name}</Typography.Text>
    </Space>
  );
};

